  document.addEventListener('DOMContentLoaded', () => {
    const counters = document.querySelectorAll('.counter');
    if (!counters.length) return;

    counters.forEach(counter => {
      const valueEl = counter.querySelector('.counter__value');
      const minusBtn = counter.querySelector('.counter__btn:not(.plus)');
      const plusBtn = counter.querySelector('.counter__btn.plus');

      if (!valueEl || !minusBtn || !plusBtn) return;

      let value = parseInt(valueEl.textContent, 10) || 0;

      minusBtn.addEventListener('click', () => {
        if (value > 0) {
          value -= 1;
          valueEl.textContent = value;
        }
      });

      plusBtn.addEventListener('click', () => {
        value += 1;
        valueEl.textContent = value;
      });
    });

    const infoBlocks = document.querySelectorAll('.question__info');
    if (!infoBlocks.length) return;

    infoBlocks.forEach(block => {
      const btn = block.querySelector('.question__btn');
      if (!btn) return;

      btn.addEventListener('click', (e) => {
        e.stopPropagation(); // чтобы не сработал document.onclick
        // Закрываем все остальные
        infoBlocks.forEach(b => {
          if (b !== block) b.classList.remove('active');
        });
        block.classList.toggle('active');
      });
    });

    // Закрываем по клику вне любого .question__info
    document.addEventListener('click', (e) => {
      infoBlocks.forEach(block => {
        if (!block.contains(e.target)) {
          block.classList.remove('active');
        }
      });
    });
  });